module.exports = __webpack_public_path__ + "caret-b048cb08415371884d94821ace168933.svg";